/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCartItemItemRequestBuilder, WithCartItemItemRequestBuilderNavigationMetadata, WithCartItemItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/item
 */
export interface Item_EscapedRequestBuilder extends BaseRequestBuilder<Item_EscapedRequestBuilder> {
    /**
     * Gets an item from the OrderApiClient.cart.item.Item_Escaped.item collection
     * @param cartItemId Unique identifier of the item
     * @returns {WithCartItemItemRequestBuilder}
     */
     byCartItemId(cartItemId: string) : WithCartItemItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const Item_EscapedRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/item";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const Item_EscapedRequestBuilderNavigationMetadata: Record<Exclude<keyof Item_EscapedRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCartItemId: {
        requestsMetadata: WithCartItemItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCartItemItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["cartItemId"],
    },
};
/* tslint:enable */
/* eslint-enable */
